module.exports = __webpack_public_path__ + "static/map-a724440d8fd979202159aaac8f9572c2.svg";